/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import bgImage from "assets/images/forget-pass.jpg";
import { Link, useNavigate } from "react-router-dom";
import validator from "validator";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { appConstants } from "utils/appConstants";
import { Box, Card, Grid, Modal } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import LoginLayout from "layouts/loginLayout/loginLayout";
import { forgotUserPassword } from "utils/authApi";
import { useDispatch } from "react-redux";
import { showResMsg } from "utils/generic";
import ForgotPassLayout from "layouts/forgotPassLayout/forgotPassLayout";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CustomText from "components/customtext/customtext";
import Swal from "sweetalert2";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { useMaterialUIController } from "context";
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
};
function Login({ ...props }) {
  const navigate = useNavigate();
  const [emailErr, setemailErr] = useState(false);
  const [emailTitleErr, setemailTitleErr] = useState('');
  const [emailErr1, setemailErr1] = useState(false);
  const [openForgotResponseModal, setOpenForgotResponseModal] = useState(false);
  const dispatch = useDispatch()
  const [values, setValues] = React.useState({
    emailAddress: "",
    currentMail: "",
    loginURL: appConstants.loginURL,
  });

  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
    if (event.target.validity.valid) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  if (
    sessionStorage.getItem("LOGIN_EMAIL") != undefined ||
    sessionStorage.getItem("LOGIN_EMAIL") != null
  )
    values.currentMail = sessionStorage.getItem("LOGIN_EMAIL").replaceAll('"', "");

  let mandateFlag = false;
  const checkEmail = async () => {
    setemailErr(false);
    try {
      if (values.emailAddress.toString().trim() === "") {
        setemailErr1(false);
        setemailTitleErr("Email Address can't be blank");
        setemailErr(true);
        mandateFlag = true;
      } else setemailErr(false);
      if (values.emailAddress.toString().trim() !== "") {
        if (!validator.isEmail(values.emailAddress)) {
          setemailErr(true);
          setemailTitleErr("Enter valid Email Address.");
          mandateFlag = true;
          setemailErr1(false);
        } else setemailErr(false);
      }
      if (mandateFlag) {
        return;
      }

      forgotUserPassword(values, (data) => {
        if (data.Result_Status) {
          sessionStorage.setItem("FORGOT_PASS_USER_DETAILS", JSON.stringify(data.Result_Output));
          sessionStorage.setItem("RESET_PASSWORD", JSON.stringify("true"));
          Swal.fire({
            title: "<span style='font-size: 16px; margin-top: -5px'>Password reset successfully.</span>",
            html: "<span style='font-size: 14px;'>A temporary password has been sent to your email address.<br/>Please check your inbox and login with temporary password.</span>",
            icon: "success",
            confirmButtonText: 'Ok',
            allowOutsideClick: false, allowEnterKey: false, allowEscapeKey: false,
            customClass: {
              popup: 'custom-popup-height',
              confirmButton: 'custom-confirm-button'
            }
          }).then((isConfirmed) => {
            navigate('/login')
          });
        } else {
          showResMsg(data.Result_Message, 2000, data.Result_Status);
        }
      }, dispatch)
    } catch (error) {
      console.log("Forget Password Error: ", error);
    }
  };

  return (
    <ForgotPassLayout image={bgImage}>
      <Card >
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Forgot Password?
          </MDTypography>
        </MDBox>
        <Grid container sx={{ justifyContent: "center" }} px={6}>
          <Grid item xs={12} lg={12} md={12} my={3}>
            <CustomText className={darkMode ? "white" : "black"} type="p" center style={{ fontSize: "14px", fontWeight: "500", color: "black" }}>
              Enter your email and we'll send you a temporary password in your register email address.
            </CustomText>
          </Grid>
          <Grid item xs={12} lg={12} md={12}>
            <MDInput
              type="email"
              label="Email Address"
              variant="outlined"
              fullWidth
              value={values.emailAddress}
              inputProps={{
                maxLength: 50
              }}
              onChange={handleChange("emailAddress")}
            />
            <span style={errMsg}> {emailTitleErr}</span>
          </Grid>

        </Grid>

        <Grid container mt={2} spacing={2} pb={3} px={6} sx={{ justifyContent: "center" }}>
          <Grid item xs={12} lg={12} md={12}>
            <MDButton variant="gradient" color="success" fullWidth onClick={checkEmail}>
              Submit
            </MDButton>
          </Grid>
          <Grid item xs={6} lg={12} md={6} >
            <Link to={"/login"}>
              <CustomText type="p" center color="secondary" style={{ textDecoration: "underline" }}>
                <ArrowBackIosIcon color="black" /> Back to Login

              </CustomText>
              {/* <MDTypography fontWeight="medium" variant="gradient" color="secondary" sx={{ justifyContent: "center", textDecoration: "underline" }}>
                <ArrowBackIosIcon color="black" /> Back to Login
              </MDTypography> */}
            </Link>
          </Grid>

        </Grid>

        {/* <Modal
          open={openForgotResponseModal}
          onClose={() => setOpenForgotResponseModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Card sx={style}>
            <Box>
              <MDTypography type="h3" id="modal-modal-title" center={true} size={18}>
                Temporary password has been sent to your email address.
              </MDTypography>
              <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                <Link to={"/login"}>
                  <MDButton
                    color="success"
                    className="modal-btn action-btn btn-success"
                    onClick={() => setOpenForgotResponseModal(false)}
                  >
                    Ok
                  </MDButton>
                </Link>
              </Grid>
            </Box>
          </Card>
        </Modal> */}
      </Card>
    </ForgotPassLayout>
  );
}

export default Login;